export default function PartnershipBenefits() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Avantages de nos <span className="text-red-600">Partenariats</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez les bénéfices exclusifs de travailler avec Cobra Sécurité et nos partenaires de confiance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-award-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Qualité Garantie</h3>
            <p className="text-gray-600">
              Produits certifiés et testés par nos partenaires leaders du marché de la sécurité.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-price-tag-3-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Prix Préférentiels</h3>
            <p className="text-gray-600">
              Bénéficiez de tarifs avantageux grâce à nos accords commerciaux privilégiés.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-tools-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Support Technique</h3>
            <p className="text-gray-600">
              Assistance technique directe de nos partenaires pour une installation optimale.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-time-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Livraison Rapide</h3>
            <p className="text-gray-600">
              Stock disponible et livraison express grâce à notre réseau de distribution.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-shield-check-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Garantie Étendue</h3>
            <p className="text-gray-600">
              Garanties constructeur étendues et service après-vente de qualité.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-graduation-cap-line text-2xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Formation Continue</h3>
            <p className="text-gray-600">
              Formations régulières sur les nouvelles technologies et produits.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
